import { createContext } from 'react'

import { UserWorkspacesContextType } from './types'

export const UserWorkspacesContext = createContext<UserWorkspacesContextType>(
  {} as UserWorkspacesContextType,
)
